import styled from 'styled-components';

export const Wrapper = styled.div`
  max-height: 400px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
`;
